import client from './client'

interface ApiResponse<T> {
  code: number
  data: T
  message?: string
}

interface FreeQuota {
  left: number
  total: number
}

export async function createAccount(params: { account: string; publicKey: string; token: string }) {
  const result = await client.post<unknown, ApiResponse<unknown>>('/account/register', params)
  return { status: !result.code, data: result.data, message: result.message }
}

export async function getFreeQuota() {
  const result = await client.get<unknown, ApiResponse<FreeQuota>>('/account/quote')
  return { status: !result.code, data: result.data }
}
